// extracted by mini-css-extract-plugin
module.exports = {"default":"ErrorMessage_default__2F7st","center":"ErrorMessage_center__cfe9r"};